import React, { useEffect, useState } from 'react'
import { adminGetUserListForCounselApi } from '../../../api/admin/counsel'

import { Link, useLocation } from 'react-router-dom'
import { swalErrorAlert } from '../../../utils/swal/swal'
import { SearchForm } from '../common/SearchForm'
import TablePagination from '../../../components/common/TablePagination'

const AdminCounselMain = () => {
  const location = useLocation();
  const pathname = location.pathname
  const params = new URLSearchParams(location.search);
  const searchTerm = params.get('search')

  return (
    <div className="container-fluid">
      {/* Page Heading */}
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0">상담내용 관리</h1>
      </div>

      {/* Content Row */}
      <div className="card shadow mb-4">

        <div className="card-header py-3">
          <div className='d-flex justify-content-between align-items-center'>
            <h6 className="m-0 font-weight-bold">학생 리스트</h6>
            <SearchForm pathname={pathname} searchTerm={searchTerm} placeHolder={'학생 이름을 검색해 주세요.'} />
          </div>
        </div>

        <div className="card-body" style={{ height: "calc(100vh - 320px)", overflow: "auto" }}>
          <div className="">
            <CounselUserList searchTerm={searchTerm} />
          </div>
        </div>

      </div>
    </div>
  )
}



/* 학생 리스트 */
const CounselUserList = ({ searchTerm }) => {
  /* States */
  const [userList, setUserList] = useState([]) // 학생 리스트

  /* UseEffect */
  useEffect(() => {
    getUserList(searchTerm)
  }, [searchTerm])

  /* Methods */
  const getUserList = async (searchTerm) => {
    try {
      const response = await adminGetUserListForCounselApi(searchTerm)

      if (response.data.code === 200) {
        const userList = response.data.resData
        setUserList(userList)
      }
    } catch (error) {
      swalErrorAlert()
      setUserList([])
    }
  }

  /* Pagination */ //⚽ 코드 줄일 수 있는 방법 
  const itemsPerPage = 10
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = userList.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(userList.length / itemsPerPage);
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % userList.length;
    setItemOffset(newOffset);
  };


  return (
    <table className='table table-bordered align-middle' style={{ width: "auto", tableLayout: "fixed" }}>
      <colgroup>
        <col width={"200px"} />
        <col width={"400px"} />
        <col width={"200px"} />
      </colgroup>
      <thead>
        <tr className='table-secondary'>
          <th>이름</th>
          <th>이메일</th>
          <th className='text-center'>상담 내용 보기</th>
        </tr>

      </thead>
      <tbody>
        {currentItems &&
          currentItems.map((user) =>
            <UserListItem key={'userlist-' + user.user_id} userProp={user} />
          )
        }
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={3}>
            <div className='text-center'>
              {/* 페이지네이션 컴포넌트 */}
              <TablePagination
               handlePageClick={handlePageClick}
                pageCount={pageCount} 
                />
            </div>
          </td>
        </tr>
      </tfoot>

    </table>
  )
}


const UserListItem = ({ userProp }) => {
  const user = userProp ? userProp : null

  return (
    <tr>
      <td>{user.user_name}</td>
      <td>{user.email}</td>
      <td className='text-center'>
        <Link to={`/hy-admin/counsel/list/${user.user_id}`} className='btn btn-outline-secondary btn-sm'>상담 내용 보기</Link>
      </td>
    </tr>
  )
}

export default AdminCounselMain